import { render, staticRenderFns } from "./widgets-search.vue?vue&type=template&id=23b48e86&scoped=true"
import script from "./widgets-search.vue?vue&type=script&lang=js"
export * from "./widgets-search.vue?vue&type=script&lang=js"
import style0 from "./widgets-search.vue?vue&type=style&index=0&id=23b48e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b48e86",
  null
  
)

export default component.exports